import React from 'react';
import { Row, Card } from '~/components';
import { AA_DISABLED_BORDER } from '~/modules/Helper/contrast.helper';

const selectStyle = {
  width: 80,
  marginLeft: 5,
  height: 32,
  borderRadius: 2,
  border: `1px solid ${AA_DISABLED_BORDER}`,
};

const labelStyle = {
  fontSize: 18,
  fontWeight: 500,
  marginBottom: 0,
  color: 'rgba(0, 0, 0, 0.85)',
};

/**
 * Select nativo + label visível — evita aria-required-attr do Antd 4
 * e AccessMonitor label_03 (só aria-label / heading falso).
 */
export default function FiltroExercicio({
  handleChangeExercicio,
  exercicios,
  exercicio,
}) {
  return (
    <Row style={{ justifyContent: 'flex-start', marginTop: '10px' }}>
      <Card
        style={{ width: '100%' }}
        bodyStyle={{
          display: 'flex',
          alignItems: 'center',
          padding: 12,
        }}
      >
        <label htmlFor="estatisticas-filtro-exercicio" style={labelStyle}>
          Exercício
        </label>
        <select
          id="estatisticas-filtro-exercicio"
          value={exercicio}
          onChange={event =>
            handleChangeExercicio(Number(event.target.value))
          }
          style={selectStyle}
        >
          {exercicios.map(ano => (
            <option key={ano} value={ano}>
              {ano}
            </option>
          ))}
        </select>
      </Card>
    </Row>
  );
}
